import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { gsap, Elastic } from "gsap/all";
import useDisableBrowserBack from "../../hooks/useDisableBrowserBack";

  function  EndScreen() {
    useDisableBrowserBack();
    const { t } = useTranslation();

    // animations
   let titleRef = useRef(null);
   let content1Ref = useRef(null);
   let content2Ref = useRef(null);
   let image1Ref = useRef(null);
   let image2Ref = useRef(null);
   let image3Ref = useRef(null);
   let buttonRef = useRef(null);
 
   const [animation, setAnimation] = useState(null);

   useEffect(()=> {
    document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#FAF1E2');

    setAnimation(gsap.timeline()
      .fromTo(titleRef, { opacity: 1, y: 300}, {opacity: 1, y: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(content1Ref, { opacity: 1, x: -600}, {x: 0, opacity: 1, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(content2Ref, { opacity: 1, x: -600}, {x: 0, opacity: 1, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(image1Ref, { opacity: 1, x: -600}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(image2Ref, { opacity: 1, x: -600}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(image3Ref, { opacity: 1, x: -600}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
      .fromTo(buttonRef, { opacity: 1, x: 600}, {opacity: 1, x: 0, duration: 0.5, ease: Elastic.easeOut(1, 0.3)})
    );

  }, []);

    return (
      <div className="mobile-container end-screen">
        <div className="content-wrapper">
            <h3 ref={ e => { titleRef = e }}>{t("student.end_screen.title")}</h3>
            <p ref={ e => { content1Ref = e }}>{t("student.end_screen.message_1")}</p>
            <p ref={ e => { content2Ref = e }}>{t("student.end_screen.message_2")}</p>

            <div className="meme-image-wrapper">
              <img src="https://picsum.photos/id/1/136/119" alt="meme" className="image image-1" ref={ e => { image1Ref = e }} />
              <img src="https://picsum.photos/id/10/136/119" alt="meme" className="image image-2" ref={ e => { image2Ref = e }} />
              <img src="https://picsum.photos/id/15/136/119" alt="meme" className="image image-3" ref={ e => { image3Ref = e }} />
              <a href="https://www.medievalmemes.nl/" className="button button-primary" ref={ e => { buttonRef = e }}>{t("student.end_screen.button_text")}</a>
            </div>
        </div>
      </div >
    );
}

export   default  EndScreen;